export const version = '1.15.2'
